import { type ReactElement } from "react";
import { useDarkMode, useLanguage } from "@/context";
import { useScrollReveal } from "@/hooks";
import { Label, Card } from "@/components";
import { projectsData, t } from "@/data";

export const Projects = (): ReactElement => {
  const { modeClass } = useDarkMode();
  const { lang } = useLanguage();
  const { ref, revealed } = useScrollReveal<HTMLElement>();

  return (
    <section id="projects" ref={ref} className={`projects scroll-reveal${revealed ? " revealed" : ""} ${modeClass}`} aria-label={t(lang, "projectsSection")}>
      <div className="container">
        <Label text={t(lang, "projectsLabel")} labelType="open" modeClass={modeClass} />
        <p></p>
        <ul className="card-project" role="list">
          {projectsData.map((project, index) => (
            <li key={index}>
              <Card data={project} />
            </li>
          ))}
        </ul>
        <Label
          text={t(lang, "projectsCloseLabel")}
          labelType="close"
          modeClass={modeClass}
        />
      </div>
    </section>
  );
};
